// 「地域を選択」のモーダル（2026の見た目）で使う、都道府県の並べ方。
// ヘッダーのモーダル（app/views/top/_pref_selector.html.erb）と同じ並びにそろえている。
// 見た目の並べ方だけで、選んだときの動きには関わらない

// 地方ごとのまとまりと、先頭に置く県（大きな都市がある順）
const REGIONS = [
  ['北海道・東北', 1, 7, [1, 4, 7, 2, 3, 6, 5]],
  ['関東', 8, 14, [13, 14, 11, 12]],
  ['中部', 15, 23, [23, 22, 15, 20, 21, 17, 19, 16, 18]],
  ['関西', 24, 30, [27, 26, 28, 29, 25, 24, 30]],
  ['中国・四国', 31, 39, [34, 33, 35, 32, 31, 38, 37, 36, 39]],
  ['九州・沖縄', 40, 47, [40, 43, 46, 42, 44, 45, 41, 47]],
];

// 「東京都」→「東京」のように末尾の 都・府・県 は省く（北海道はそのまま）
export const shortPrefName = (name) =>
  name === '北海道' ? name : name.replace(/[都府県]$/, '');

// [{ label, prefs }] の形で、地方ごとに並べた都道府県を返す。
// 47都道府県の番号に当てはまらないものがあっても消さずに、最後の「その他」に出す
export const groupPrefsByRegion = (countriesPrefs) => {
  const regions = REGIONS.map(([label, from, to, tops]) => {
    const orderOf = (id) => {
      const index = tops.indexOf(id);
      return index === -1 ? tops.length : index;
    };
    const prefs = countriesPrefs
      .filter((pref) => pref.id >= from && pref.id <= to)
      .sort((a, b) => orderOf(a.id) - orderOf(b.id) || a.id - b.id);
    return { label, prefs };
  });
  const others = countriesPrefs.filter((pref) => pref.id < 1 || pref.id > 47);
  return [...regions, { label: 'その他', prefs: others }].filter(
    (region) => region.prefs.length > 0
  );
};
